<template>
  <v-app id="inspire">
    <v-dialog v-model="open" scrollable max-width="640px">
      <v-card>
        <!-- Header -->
        <v-card-title>
          <div class="c-flex js ac w100">
            <div class="c-title s">
              {{ event.title }}
            </div>
            <v-icon small class="c-close" @click="open = false">close</v-icon>
          </div>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-flex class="js as w100">
            <div class="c-flex as c-time">
              <v-icon>access_time</v-icon>
              <div class="s c-time-c" v-html="fromTo"></div>
            </div>
          </v-flex>
          <v-flex v-if="event.location">
            <div class="c-flex as c-loc" @click="goLocation(event.location)">
              <v-icon>location_on</v-icon>
              <div class="s c-loc-c">{{ event.location }}</div>
            </div>
          </v-flex>
          <v-flex v-if="item.desc" class="js as w100 c-doc" v-html="formatExplain(item.desc)"></v-flex>

          <v-flex>
            <div class="c-flex js as w100 c-ft">
              <selected-members
                ref="sm"
                :cid="item.community_id"
                :memberGroups="shareMembers"
                :creatorCmid="item.creator_cmid"
                :onlyCreator="onlyCreator"
                :offOpacity="0.85"
                iconColor="clr-gray"
                type="calendar"
                :typeId="item.id"
                :friends="curFriends"
                @memberRequested="loadShareMembers()"
              ></selected-members>
            </div>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>

        <!-- Footer -->
        <v-card-actions>
          <v-tooltip bottom class="c-btn">
            <v-btn slot="activator" flat icon color="clr-black" :disabled="!isOwner" @click.prevent="onTrash">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
            <span>{{ $T('button.delete') }}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom class="c-btn">
            <v-btn slot="activator" flat icon color="clr-black" :disabled="!editable" @click.prevent="onEdit">
              <v-icon>mdi-calendar-edit</v-icon>
            </v-btn>
            <span>{{ $T('common.edit') }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm-dialog
      v-if="deleteConfirm != null"
      ref="deleteConfirm"
      :open="deleteConfirm != null"
      :dialogKey="'delete'"
      :confirmValue="1"
      persistent
      :errMsg="deleteConfirm.errMsg"
      :dialogTitle="$T('page.cal.delete.title')"
      :dialogText="$T('page.cal.delete.msg')"
      @ok="onDeleteOk"
      @cancel="onDeleteCancel"
    />

    <v-dialog v-model="deleteRepeatDialog" max-width="400px">
      <v-card>
        <!-- Header -->
        <v-card-title>
          <div class="c-flex js ac w100">
            <div class="c-title s">
              {{ $T('page.cal.delete.title') }}
            </div>
            <v-icon small class="c-close" @click="deleteRepeatDialog = false">close</v-icon>
          </div>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-flex class="c-msg">{{ $T('page.cal.repeat.delete.confirm') }}</v-flex>
        </v-card-text>
        <v-divider></v-divider>

        <!-- Footer -->
        <v-card-actions>
          <v-container grid-list-md text-xs-center class="c-action-container">
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn
                  slot="activator"
                  round
                  dark
                  color="clr-primary"
                  @click.prevent="onDeleteOk"
                  :loading="deleting === 'all'"
                  :disabled="!!deleting"
                  class="w100"
                >
                  {{ $T('page.cal.repeat.delete.to_all') }}
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  slot="activator"
                  round
                  dark
                  color="clr-primary"
                  @click.prevent="onDeleteOnlyThis"
                  :loading="deleting === 'this'"
                  :disabled="!!deleting"
                  class="w100 c-btn-tail"
                >
                  {{ $T('page.cal.repeat.delete.to_this') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { getShareMembers, getShareTargets, deleteEvent, deleteOnlyOneEvent } from '../../api/communityEvent';
export default {
  props: ['event', 'friends'],
  data() {
    return {
      open: true,
      show: true,
      deleteConfirm: null,
      datetimeDialog: false,
      deleteRepeatDialog: false,
      deleting: null,
      shareTargets: null,
      curFriends: this.friends || {},
    };
  },
  mounted() {
    if (open) {
      this.$store.commit('CAL_DIALOG_DETAIL', true);
      this.$nextTick(function() {
        this.$refs.sm.loadMember();
      });
    }
  },
  watch: {
    open(n, o) {
      this.$store.commit('CAL_DIALOG_DETAIL', n);
      if (n) {
        this.$nextTick(function() {
          this.$refs.sm.loadMember();
        });
      } else {
        this.$emit('close');
      }
    },
    stateUpdatedEvents(n, o) {
      this.open = false;
    },
    stateDeletedEvents(n, o) {
      this.open = false;
    },
  },
  computed: {
    item() {
      return this.event.item;
    },
    allDay() {
      return this.item.allDay;
    },
    isOwner() {
      return this.item.is_creator;
    },
    fromTo() {
      var s = this.toNewMoment(this.event.startD);
      var e = this.toNewMoment(this.event.endD);
      if (this.item.all_day) {
        if (this.isSameDay(s, e)) return this.toYmd(s);
        if (this.leTbS) return `<div>${this.toYmd(s)} -<div><div>${this.toYmd(e)}</div>`;
        return `${this.toYmd(s)} - ${this.toYmd(e)}`;
      }
      if (this.isSameDay(s, e)) return `${this.toYmdHm(s)} - ${this.toHm(e)}`;
      if (this.leTbS) return `<div>${this.toYmdHm(s)} -</div><div>${this.toYmdHm(e)}</div>`;
      return `${this.toYmdHm(s)} - ${this.toYmdHm(e)}`;
    },
    editable() {
      if (this.item.is_creator) return true;
      var c = this.cMap[this.item.community_id];
      return this.item.editable && c && (c.f || c.pm || c.role == 1 || c.role == 2);
    },
    stateDeletedEvents() {
      return this.$store.state.calendar.deletedEvents;
    },
    stateUpdatedEvents() {
      return this.$store.state.calendar.updatedEvents;
    },
    isCreator() {
      return this.item.creator_cmid == this.cidToCmid(this.item.community_id);
    },
    onlyCreator() {
      return !this.shareTargets;
    },
    shareMembers() {
      var arr = [`m${this.item.creator_cmid}`];
      return this.shareTargets ? arr.concat(this.shareTargets) : arr;
    },
  },
  methods: {
    goLocation(loc) {
      if (!loc) return;
      // window.open(this.$utils.toMapUrl(loc), '_gmap');
      window.open(this.$utils.toMapUrl(loc));
    },
    isSameDay(a, b) {
      return a.format('YYYYMMDD') == b.format('YYYYMMDD');
    },
    toNewMoment(v) {
      if (Number.isInteger(v)) return this.$moment.unix(v);
      if (typeof v === 'string' || v instanceof String) return this.$moment(v, 'YYYY-MM-DD HH:mm');
      // not use unix because timezone will be defferent.
      return this.$moment(v.format('YYYYMMDDHHmm'), 'YYYYMMDDHHmm');
    },
    toYmd(m) {
      var f =
        this.userCountry == 'us' && this.userLang == 'en' ? $T('common.moment.us.ymdw') : $T('common.moment.ymdw');
      return m.format(f);
    },
    toHm(m) {
      return m.format('HH:mm');
    },
    toYmdHm(m) {
      return `${this.toYmd(m)} ${this.toHm(m)}`;
    },
    formatExplain(desc) {
      return formatExplain(desc);
    },
    onEdit() {
      (async () => {
        try {
          if (this.item.is_creator) {
            const response = await getShareTargets(this.item.id);
            this.commitEdit(response.targets);
          } else {
            const response = await getShareMembers(this.item.id);
            const keys = [];
            for (const cmid of response) keys.push(`m${cmid}`);
            this.commitEdit(keys);
          }
        } catch (e) {
          console.error('failed to get data', e);
          this.errGetData();
        }
      })();
    },
    commitEdit(members) {
      this.$store.commit('CAL_UPDATE', { item: this.cloneCalEvent(), members: members });
    },
    onTrash() {
      if (this.event.uid) {
        this.deleteRepeatDialog = true;
      } else {
        this.deleteConfirm = { errMsg: null };
      }
    },
    onDeleteOk() {
      this.deleting = 'all';
      var self = this;
      deleteEvent(this.item.id)
        .then(function(response) {
          self.deleting = null;
          self.deleteRepeatDialog = false;
          self.deleteConfirm = null;
          self.$store.commit('CAL_DELETED', { item: self.item });
          self.shortMsg($T('common.succeed.delete'));
          self.open = false;
        })
        .catch(function(error) {
          self.deleting = null;
          console.warn('failed to delete file.', error);
          self.shortMsg($T('common.failed.delete'), true);
        });
    },
    onDeleteOnlyThis() {
      this.deleting = 'this';
      var self = this;
      deleteOnlyOneEvent(this.item.id, this.event.uid)
        .then(function(response) {
          self.deleting = null;
          self.deleteRepeatDialog = false;
          // delete-one returns { event: <Event|null> } (PHP getEvent()['event']); null = last one removed.
          var newEvent = response.data.event;
          if (newEvent) {
            self.$store.commit('CAL_APPEND_UPDATED', { old: self.item, item: newEvent });
          } else {
            // delete last one.
            self.$store.commit('CAL_DELETED', { item: self.item });
          }
          self.shortMsg($T('common.succeed.delete'));
          self.open = false;
        })
        .catch(function(e) {
          self.deleting = null;
          console.warn('failed to delete.', e);
          self.shortMsg($T('common.failed.delete'), true);
        });
    },
    cloneCalEvent() {
      var e = this.event;
      return {
        start: e.start,
        end: e.end,
        startD: e.startD,
        endD: e.endD,
        allDay: e.allDay,
        item: e.item,
        uid: e.uid,
      };
    },
    onDeleteCancel() {
      this.deleteConfirm = null;
    },
    loadShareMembers() {
      var self = this;
      getShareMembers(this.item.id)
        .then(response => {
          var cmids = response;
          var ids = [];
          for (var cmid of response) ids.push(`m${cmid}`);
          self.shareTargets = ids;
        })
        .catch(e => {
          console.error('failed to get data', e);
          self.errGetData();
        });
    },
  },
};
</script>

<style scoped>
.c-title {
  font-size: 16px;
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
}
.le-tbs .c-title {
  font-size: 14px;
}
.c-com-i {
  margin-top: 2px;
}
.c-to-list {
  margin-top: 7px;
}
.c-to-list .c-fl {
  margin-right: 5px;
}
.c-ft {
  margin: 15px 0 0 -4px;
}
.c-time {
  margin-top: 5px;
}
.c-time-c {
  margin-top: 1px;
  display: flex;
  flex-direction: column;
}
.c-time i {
  margin-right: 3px;
}
.c-loc {
  margin-top: 5px;
  cursor: hand;
  cursor: pointer;
}
.c-loc-c {
  margin-top: 1px;
}
.c-loc i {
  margin-right: 3px;
}
.c-doc {
  margin-top: 15px;
}
.c-action-container {
  padding: 3px 20px 5px 20px;
}
</style>
